import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, nextTick, onMounted, ref, useSlots, VNode, watch, watchEffect } from 'vue';
import type { SelectStore } from './select.vue';
import type { StyleValue } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'option',
  props: {
    value: {},
    iconStyle: { type: [Boolean, null, String, Object, Array] },
    prefixStyle: { type: [Boolean, null, String, Object, Array] },
    suffixStyle: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/22 14:17:46
 * @description: 下拉框选项
 */
const slot = useSlots();
const props = __props;
const selectStore = inject<SelectStore>('selectStore', {});
const label = ref<string>('');
const iconRef = ref<VNode | null>(null);
const handleSelect = () => {
  selectStore.visable = false;
  selectStore.value = props.value;
};
onMounted(() => {
  const children = slot.default?.();
  const icon = slot.icon?.();
  const childrenNode = Array.isArray(children) ? children[0] : children;
  const iconNode = Array.isArray(icon) ? icon[0] : icon;
  if (typeof childrenNode?.type !== 'symbol') return;
  label.value = String(childrenNode.children) ?? '';
  iconRef.value = iconNode ?? null;
});

watch(
  () => selectStore.value,
  () => {
    if (selectStore.value === props.value) {
      nextTick(() => {
        selectStore.label = label.value;
        selectStore.icon = iconRef.value;
      });
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    key: __props.value,
    class: _normalizeClass(['select-option', _unref(selectStore).value === __props.value && 'select-option--active']),
    onClick: handleSelect
  }, [
    _createElementVNode("span", {
      class: "icon",
      style: _normalizeStyle(__props.iconStyle)
    }, [
      _renderSlot(_ctx.$slots, "icon")
    ], 4),
    _createElementVNode("span", {
      class: "prefix",
      style: _normalizeStyle(__props.prefixStyle)
    }, [
      _renderSlot(_ctx.$slots, "prefix")
    ], 4),
    _createTextVNode(" " + _toDisplayString(label.value) + " ", 1),
    _createElementVNode("span", {
      class: "suffix",
      style: _normalizeStyle(__props.suffixStyle)
    }, [
      _renderSlot(_ctx.$slots, "suffix")
    ], 4)
  ], 2))
}
}

})